import { render, staticRenderFns } from "./GestioneAziende.vue?vue&type=template&id=3521e022&"
import script from "./GestioneAziende.vue?vue&type=script&lang=js&"
export * from "./GestioneAziende.vue?vue&type=script&lang=js&"
import style0 from "./GestioneAziende.vue?vue&type=style&index=0&id=3521e022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports